export const STATUS_MESS = {
  SUCCESS: 1,
  PENDING: 2,
  ERROR: 3,
  PROCESSING: 4,
}

export const USER_TYPE_CODE = {
  USER: 'U',
  BOT: 'B',
  STAFF: 'S',
  SYSTEM: 'SYSTEM',
}
